import { ProductDto } from "src/app/core/dtos/dto";
import { ProductSortTypeOrderEnum } from "src/app/core/dtos/enum";

export const productSortTypeOrderMapping = [
  { value: ProductSortTypeOrderEnum.PopularityHighToLow, sortRule: (a: ProductDto, b: ProductDto) => a.displayOrder - b.displayOrder },
  { value: ProductSortTypeOrderEnum.PopularityHighToLow, sortRule: (a: ProductDto, b: ProductDto) => a.displayOrder - b.displayOrder },
  { value: ProductSortTypeOrderEnum.PopularityLowToHigh, sortRule: (a: ProductDto, b: ProductDto) => b.displayOrder - a.displayOrder },
  { value: ProductSortTypeOrderEnum.PriceHighToLow, sortRule: (a: ProductDto, b: ProductDto) => b.listPrice - a.listPrice },
  { value: ProductSortTypeOrderEnum.PriceLowToHigh, sortRule: (a: ProductDto, b: ProductDto) => a.listPrice - b.listPrice }
];
